var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5007 2L34.9973 17.3333V42.6333C34.9973 45.5973 32.7257 48 29.9235 48H5.57382C2.77163 48 0.5 45.5973 0.5 42.6333V7.36667C0.5 4.40274 2.77163 2 5.57382 2H20.5007Z",
    fill: "url(#paint0_linear_12776_42621)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12776_42621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 17.3359H25.8335C23.0313 17.3359 20.5034 14.6621 20.5034 11.6982V2.0026L35 17.3359Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.334 39.4004H10.0859V37.4844H17.334V39.4004ZM24.582 35.5654H10.0859V33.6484H24.582V35.5654ZM24.582 31.7363H10.0859V29.8193H24.582V31.7363ZM24.582 27.9004H10.0859V25.9844H24.582V27.9004Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12776_42621",
    x: 19.5,
    y: 0,
    width: 16.5,
    height: 17.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12776_42621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12776_42621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12776_42621",
    x1: 0.5,
    y1: 2,
    x2: 0.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDF-Icon.b10e37dbb416faa84dca6f2035a1e123.svg";
export { ForwardRef as ReactComponent };